export default __webpack_public_path__ + "static/media/step5.8acf20da.png";